import { render, staticRenderFns } from "./AdditionalsSimpleSummary.vue?vue&type=template&id=a265a9ea&scoped=true"
import script from "./AdditionalsSimpleSummary.vue?vue&type=script&lang=js"
export * from "./AdditionalsSimpleSummary.vue?vue&type=script&lang=js"
import style0 from "./AdditionalsSimpleSummary.vue?vue&type=style&index=0&id=a265a9ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a265a9ea",
  null
  
)

export default component.exports